import styled from 'styled-components';

export const HeadingImage = styled.img`
  max-width: 200px;
`;
